/**
 * Definition of all routes of the application.
 */
export const routes = {
  userList: {
    url: 'userList',
    absoluteUrl: '/userList',
  },
  unhandledError: {
    url: 'serverUnhandledError',
    absoluteUrl: '/serverUnhandledError',
  },
};
